import React, { Component } from 'react';
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from './InitialMainProfile.jsx';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'redux';
import { Button } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import LogoutAlert from '../../components/Alert/LogoutAlert.jsx';
import UpdateProfile from './UpdateProfile.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import { ROLE_CUSTOMER, ROLE_PROVIDER } from '../../utils/config/constants.js';
import { withRouter } from 'react-router-dom';

const styles = theme => ({
    card: {
        color: theme.palette.secondary.main
    }
});
const sendProps = props => {
    const { classes, ...rest } = props;
    return rest;
};
class ProfileDashboard extends Component {
    constructor() {
        super();
       
        this.state = { update: false, showAlert:false };
    }
    handleAlert=()=>{
        this.setState({ showAlert: true }); 
    }
    profileUpdate = () => {
        this.setState({ update: true });
    };
    showProfile = () => {
        this.setState({ update: false });
    };
    updateDone = () => {
        this.setState({ update: false });
        if (this.props.userData.role == ROLE_CUSTOMER) {
            this.props.history.push(`/user/profile`);
        } else if (this.props.userData.role == ROLE_PROVIDER) {
            // this.props.history.push(`/user/dashboard`);
            this.props.history.push(`/provider/dashboard`);
        }
    };
    render() {
        const { userData } = this.props;
        // console.log(this.props,' in profileDashboard')
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div>
                {/* <h4 style={{margin:4}} className="justify-content-between d-flex align-items-center">
                            {' '}
                            {userData.role == ROLE_PROVIDER ? userData.account_type == 2 ? (
                                  <p style={{color: "#000000" }}>{userData.businessName}</p>
                            ): (userData.account_type == 1 ? (
                                <p style={{ color: "#000000" }}>Freelancer</p>
                            ): '')  : '' }  */}
                           
                                 {/* <Button
                                 style={{
                                    background:'#ec4631' ,
                                    color:'#fff'

                                 }}
                                variant="contained"
                                // color="error"
                                onClick={this.handleAlert}
                            >
                                <FormattedMessage
                                    id="Logout"
                                    defaultMessage="Log Out"
                                />
                            </Button> */}
                            {/* <IconButton
                                color="inherit"
                                onClick={this.handleAlert}
                                aria-label="Close"
                            >
                                <CloseIcon />
                            </IconButton> */}
                        {/* </h4> */}
            
                    {/* {!this.state.update ? (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.profile"
                                defaultMessage="My Profile"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.profileUpdate}
                            >
                                <FormattedMessage
                                    id="Edit profile"
                                    defaultMessage="Edit profile"
                                />
                            
                            </Button>
                        </h4>
                    ) : (
                        <h4 className="justify-content-between d-flex align-items-center">
                            {' '}
                            <FormattedMessage
                                id="customer.updateprofile"
                                defaultMessage="Update Profile"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={this.showProfile}
                            >
                                <FormattedMessage
                                    id="customer.profile"
                                    defaultMessage="View Profile"
                                />
                            </Button>
                        </h4>
                    )} */}
                </div>
                <div style={{paddingBottom:"25px"}} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <h3>ProfileDashboard.jsx</h3> */}
                            {!this.state.update ? (
                                <InitialMainProfile {...sendProps(this.props)} />
                            ) : (
                                <UpdateProfile
                                    user={userData}
                                    updateDone={this.updateDone}
                                />
                            )}
                        </div>
                    </div>
                </div>
                <LogoutAlert
                    open={this.state.showAlert}
                    title=""
                    close={() => this.setState({ showAlert: false })}
                    handleYes={this.props.logoutCall}
                    handleNo={() => this.setState({ showAlert: false })}
                />
                    {/* <Button
                                 style={{
                                    background:'rgb(255 51 102)' ,
                                    color:'#fff',
                                    width:"-webkit-fill-available",
                                    height:"50px"

                                 }}
                                variant="contained"
                                // color="error"
                                onClick={this.handleAlert}
                            >
                               <div style={{fontWeight:"600",fontSize:"16px"}} > <FormattedMessage
                                    id="Logout"
                                    defaultMessage="Log Out"

                                />
                                </div>
                    </Button> */}
            </div>
        );
    }
}

const composedProfile = compose(withStyles(styles));
export default composedProfile(withRouter(ProfileDashboard));



// WEBPACK FOOTER //
// ./src/views/User/ProfileDashboard.jsx